import React, { useState, useEffect, useRef } from 'react'
import { FormHelperText } from '@material-ui/core';
import ThemeControls from "../Component/AllThemesControl";
import { FormContext } from '../Component/Forms/FormContext';
import elementValidate from '../Component/validation';
import { useContext } from 'react';
import { APIGET } from '../services/APIServices';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Element from '../FormsControls/Element';
import { MasterContext } from '../services/MasterContext';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
const jsonFields = {
  "page_label": "Add Multiple Techprefix",
  "fields": [
    {
      "field_id": "customtechprefix",
      "field_label": "TechPrefix",
      "field_value": "",
      "field_mandatory": "yes",
      "field_disabled": "",
      "field_placeholder": "Select",
      "field_option_src": {
        "field_option_check_local_storage": "true",
        "field_option_src_context": "ratesheet/rs/gtsVendorlookup/getlookuptechprefix",
        "field_option_src_critieria": "",
        "field_option_label": "name",
        "field_option_value": "",
        "field_select_all_label": "",
        "field_select_all_value": ""
      },
      "field_options": [],
      "field_type": "select",
      "field_minlength": "",
      "field_maxlength": "",
      "field_minvalue": "",
      "field_maxvalue": "",
      "field_value_type": "",
      "field_on_blur": "",
      "field_error_msg_required": "Please Select TechPrefix",
      "field_error_msg_minlength": "",
      "field_error_msg_maxlength": "",
      "field_error_msg_minvalue": "",
      "field_error_msg_maxvalue": "",
      "field_error_msg_uq": ""
    },
    {
      "field_id": "identifierType",
      "field_label": "Identifier",
      "field_value": "",
      "field_mandatory": "",
      "field_placeholder": "",
      "field_default_value": "S",
      "field_option_src": {
        "field_option_check_local_storage": "true",
        "field_option_src_context": "",
        "field_option_src_critieria": "",
        "field_option_label": "",
        "field_option_value": "",
        "field_select_all_label": "",
        "field_select_all_value": ""
      },
      "field_options": [
        {
          "option_label": "Subject",
          "value": "S"
        },
        {
          "option_label": "FileName",
          "value": "F"
        }
      ],
      "field_type": "radio",
      "field_minlength": "",
      "field_maxlength": "",
      "field_minvalue": "",
      "field_maxvalue": "",
      "field_value_type": "",
      "field_on_blur": "",
      "field_error_msg_required": "",
      "field_error_msg_minlength": "",
      "field_error_msg_maxlength": "",
      "field_error_msg_minvalue": "",
      "field_error_msg_maxvalue": "",
      "field_error_msg_uq": ""
    },
    {
      "field_id": "content",
      "field_label": "Content",
      "field_value": "",
      "field_mandatory": "yes",
      "field_placeholder": "Enter Content",
      "field_type": "text",
      "field_minlength": "",
      "field_maxlength": "",
      "field_minvalue": "",
      "field_maxvalue": "",
      "field_value_type": "",
      "field_on_blur": "",
      "field_error_msg_required": "Please Provide Content",
      "field_error_msg_minlength": "",
      "field_error_msg_maxlength": "",
      "field_error_msg_minvalue": "",
      "field_error_msg_maxvalue": "",
      "field_error_msg_uq": ""
    }
  ]
}

const fieldColumns = [];
if (jsonFields) {
  const fieldColumn = jsonFields.fields.map((field) => ({
    key: field.field_id,
    title: field.field_label,
    dataIndex: field.field_id,
  }));
  fieldColumns.push(...fieldColumn);
}

export default function AddIdentifiers(props) {
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  const [attr, setAttr] = React.useState();
  const { id, field_type, field_apipath,field_temp_value, field_history, fields, field_disabled_Edit, field_id, field_label, field_placeholder, field_disabled, field_value, field_option_src, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, onChange, field_mandatory } = props;
  let { masterData } = React.useContext(MasterContext);
  const { handleChange } = useContext(FormContext);
  const [fieldDisable, setFieldDisable] = useState(field_disabled);
  const [checkBoxDisable, setCheckBoxDisable] = useState(true);
  const [fieldOptions, setFieldOptions] = React.useState(field_options);
  const [value, setValue] = React.useState(field_value?field_value:[{ customtechprefix: '', identifierType: 'S', content: '' }]);
  const { contextJson } = React.useContext(FormJSONCreateContext);
  const [open, setOpen] = React.useState(false);

  async function getOptions(props) {
    try {
      if (props.field_option_src_context) {
         
        if (props.field_option_check_local_storage === "true" && (masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`])) {
          setFieldOptions(masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]);
           
        }
        else {
          let APIRES = await APIGET(props.field_option_src_context + `/` + props.field_option_src_critieria).then(
            (APIRES) => {
               
              let responseArray = new Array();
              let _i = 0;
              if (props.field_select_all_label) {
                let _obj = new Object();
                _obj.option_label = props.field_select_all_label;
                _obj.value = props.field_select_all_value;
                responseArray[_i] = _obj;
                _i++;
              }
              Object.keys(APIRES.data).forEach(key => {
                let _obj = new Object();
                function checkType(lableData) {
                  if (typeof lableData === 'string') {
                    _obj.option_label = APIRES.data[key][lableData];
                    _obj.value = APIRES.data[key][props.field_option_value];
                  } else if (Array.isArray(lableData)) {
                    let label = "";
                    for (const item of lableData) {
                      if (item.column) {
                        label += APIRES.data[key][item.column];
                      } else if (item.string) {
                        label += item.string;
                      }
                    }
                    _obj.option_label = label
                  } else {
                    // It's neither a string nor an array.
                     
                  }
                }
                function checkValueType(valueData) {
                  if (typeof valueData === 'string') {
                    _obj.value = APIRES.data[key][valueData];

                  } else if (Array.isArray(valueData)) {
                    let value = "";
                    for (const item of valueData) {
                      if (item.column) {
                        value += APIRES.data[key][item.column];
                      } else if (item.string) {
                        value += item.string;
                      }
                    }
                    _obj.value = value
                  } else {
                    // It's neither a string nor an array.
                     
                  }
                }
                checkType(props.field_option_label)
                checkValueType(props.field_option_value)
                // _obj.option_label = APIRES.data[key][props.field_option_label];
                // _obj.value = APIRES.data[key][props.field_option_value];
                _obj['attributes'] = {};
                if (field_option_src.field_option_attributes) {
                  field_option_src.field_option_attributes.map((att) => {
                    _obj['attributes'][`data_${att}`] = APIRES.data[key][att];
                  });
                }
                responseArray[_i] = _obj;
                _i++;
              })
              setFieldOptions(responseArray);
              if (masterData[`${props.field_option_src_context}` && `${props.field_option_src_context}`]) {
                if (masterData[`${props.field_option_src_context}`][`${field_id}`]) {
                  masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                }
                else {
                  masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                  masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                }
              }
              else {
                masterData[`${props.field_option_src_context}`] = {}
                masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
              }
              // masterData[`${field_id}_${props.field_option_src_context}_${props.field_option_src_critieria}`] = responseArray;
            }
          );
        }
      }
    } catch (err) {/** TODO Do Nothing */ }
  }
  // useEffect(() => {
  //   if (props.field_option_src.field_option_src_critieria) {
  //     getOptions(field_option_src);
  //   }
  // }, [props.field_option_src?.field_option_src_critieria])

  function handlingChange(values) {
    setValue(values)
    handleChange(field_id, {}, values);
    setOpen(false);
  }

  useEffect(() => {
    if (!(field_disabled) && field_temp_value && id) {
      setValue([field_temp_value])
    }
  }, [field_temp_value, id, field_disabled]);

// console.log(field_temp_value)
// console.log(field_value)

  useEffect(() => {

      setFieldDisable(field_disabled)

      if (field_disabled) {
        const defoultValue=[
          {
            "customtechprefix": "",
            "content": "",
            "identifierType": "S"
          }
        ]
        setValue(defoultValue)
        handleChange(field_id, {}, defoultValue);
      }
    //   else{
    //     jsonFields.fields.forEach((field) => {
    //       if (field.field_id === 'customtechprefix') {
    //         field.field_option_src = field_option_src;
    //       }
    //     });
    // }
  }, [field_disabled, fieldOptions]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // setValue(field_value)
  };

  return (
    <div className={classes.inputroot}>
      {/* {field_value&&<Button onClick={handleClickOpen}>Selected{' '+field_value?.length}</Button>} */}
      <div style={{display:'flex', width:'100%', gap:"10px"}}>
        <div className={classes.btnMenu}><Button onClick={handleClickOpen} disabled={fieldDisable}>{id?"Update Identifier":"Add Identifier"}</Button></div>
        {field_value[0]?.customtechprefix && !(field_disabled) && <div className={classes.btnMenu}><p>Selected Techprefix{' : ' + field_value?.length}</p></div>}
      </div>
      <Dialog
        maxWidth='lg'
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Add Multiple Techprefix</DialogTitle>
        <DialogContent>
          {/* <SubTable fieldsData={fields.columns} apiPath={field_apipath} apiContextObj={apiContextObj} id={id} /> */}
          <AddRowComponent id={id} field_option_src={field_option_src} setData={handlingChange} handleClose={handleClose} field_value={value} fieldOptions={fieldOptions}/>
        </DialogContent>
      </Dialog>
    </div>
  )
}



const AddRowComponent = (props) => {
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  const id = props.id;
  const field_value = props.field_value;
  const field_option_list = props.field_option_src;
  const fieldOption = props.fieldOptions;
  const [validationError, setValidationError] = useState(false);
  const [dupError, setDupError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [rows, setRows] = useState(field_value);

  const handleChange = (field_id, e, value) => {
    const id = field_id.split('.')[0];
    const index = field_id.split('.')[1];
    const updatedRows = [...rows];
    updatedRows[index][id] = value;
    setRows(updatedRows);
  };
// console.log(field_value)
  function validateThisForm(data) {
    const mandatoryFields = ['customtechprefix', 'identifierType', 'content'];
    const duplicates = findDuplicates(data);
    for (const row of data) {
      for (const field of mandatoryFields) {
        if (!row[field]) {
          setValidationError(true);
          return false;
        }
      }
    }

    if (duplicates.length > 0) {
      setDupError(true);
      setValidationError(true);
      const errorMessage = `Duplicate data in ${duplicates.join(' or ')}`;
      setErrorMsg(errorMessage)
      return false;
    }
    setValidationError(false);
    return true;
  }

  function findDuplicates(data) {
    const seenCustomTechPrefix = {};
    const seenContent = {};
    const duplicates = [];

    data.forEach(item => {
      if (seenCustomTechPrefix[item.customtechprefix]) {
        duplicates.push("TechPrefix");
      } if (seenContent[item.content]) {
        duplicates.push("Content");
      } else {
        seenCustomTechPrefix[item.customtechprefix] = true;
        seenContent[item.content] = true;
      }
    });

    return duplicates;
  }

  const handleAddRow = () => {
    setRows([...rows, { customtechprefix: '', identifierType: 'S', content: '' }]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isFormValid = validateThisForm(rows);
    if (isFormValid) {
      props.setData(rows);
    }
  };
  const handleClose = (event) => {
    event.preventDefault();
    props.handleClose()
    setRows(field_value)
  };

  useEffect(() => {
    if (dupError) {
      alert(errorMsg);
      setDupError(false);
    }
  }, [dupError])
  // console.log(rows)

  return (
    <FormContext.Provider value={{ handleChange }}>
      <div className={classes.subtable}>
        <table>
          <thead>
            <tr>
              {fieldColumns.map((column) => (
                <th key={column.key}>{String(column.title)}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {jsonFields.fields.map((field, rowIndex) => (
                  <td><Element
                    key={rowIndex}
                    // field={field} 
                    field={{
                      ...field,
                      field_id: field.field_id + '.' + index,
                      field_label: "",
                      field_type: field.field_id==="customtechprefix"&&index===0&&id?"text":field.field_type,
                      field_disabled: field.field_id==="customtechprefix"&&index===0&&id?true:field.field_disabled,
                      field_option_src: id?(field.field_id==="customtechprefix"&&index!==0?field_option_list:{}):(field.field_id==="customtechprefix"?field_option_list:{}),
                      field_value: (row[field.field_id] || ''),
                      field_helperText: (validationError && !row[field.field_id] && field.field_error_msg_required),
                    }}
                  />
                  </td>
                ))}
                <td>
                  {index === 0 ? <Button onClick={() => handleAddRow(index)} disabled={rows.length===fieldOption.length}>Add</Button> : <Button onClick={() => handleRemoveRow(index)}>Remove</Button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          <Button onClick={handleSubmit}>Add Techprefix</Button>
        </DialogActions>
      </div>
    </FormContext.Provider>
  );
};


